(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name finance.privcat.factory:Privcat
   *
   * @description
   *
   */
  angular
    .module('vcfinance.privcat')
    .factory('Privcat', Privcat);
  
  
  Privcat.$inject = ['restmod'];
  function Privcat(restmod) {
    return restmod.model('/routes/privcat').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/privcat/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return this.$search({key: val});
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
